import { render } from "./CoefficientConfigDialog.vue?vue&type=template&id=5b4ef4c1&ts=true"
import script from "./CoefficientConfigDialog.vue?vue&type=script&lang=ts"
export * from "./CoefficientConfigDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__